import api from './api';

export interface ViewYoutube {
  _id?: string;
  id?: number;
  Content: string;
  Country?: string;
  View: number;
  NameChannel?: string;
  Uploader?: string;
  Linkvideo: string;
  Datetimeuploading?: string;
  status?: string;
  created_by?: number;
  created_by_username?: string;
  created_by_full_name?: string;
  created_at?: string;
  updated_at?: string;
  last_checked_at?: string;
}

export interface ViewYoutubeHistory {
  _id?: string;
  id?: number;
  viewYoutubeId: number;
  fieldName: string;
  oldValue: string;
  newValue: string;
  changedBy: string;
  createdAt?: string;
}

export interface TotalViewsResponse {
  total: number;
  start: string;
  end: string;
  daily: Array<{ date: string; view: number }>;
}

export interface DailySnapshot {
  _id?: string;
  id?: number;
  platform: string;
  snapshotDate: string;
  totalVideos: number;
  totalViews: number;
  topVideos: Array<{ videoId: string; content: string; view: number }>;
  createdAt?: string;
}

export const viewYoutubeService = {
  // Upload 1 video
  upload: async (data: Partial<ViewYoutube>): Promise<ViewYoutube> => {
    const response = await api.post<ViewYoutube>('/apiviewyoutube', data);
    return response.data;
  },

  // Upload nhiều video (batch)
  uploadBatch: async (videos: Partial<ViewYoutube>[]): Promise<ViewYoutube[]> => {
    const response = await api.post<ViewYoutube[]>('/apiviewyoutube/batch', videos);
    return response.data;
  },

  // Lấy video theo khoảng thời gian
  getByDateRange: async (start: string, end: string): Promise<ViewYoutube[]> => {
    const response = await api.get<ViewYoutube[]>('/apiviewyoutube/daterange', {
      params: { start, end }
    });
    return response.data;
  },

  // Tổng view + view theo ngày
  getTotal: async (start: string, end: string): Promise<TotalViewsResponse> => {
    const response = await api.get<TotalViewsResponse>('/apiviewyoutube/total', {
      params: { start, end }
    });
    return response.data;
  },

  // Top video có view cao nhất
  getTop: async (params?: {
    date?: string;
    start?: string;
    end?: string;
    limit?: number;
  }): Promise<ViewYoutube[]> => {
    const response = await api.get<ViewYoutube[]>('/apiviewyoutube/top', {
      params
    });
    return response.data;
  },

  // Cập nhật trạng thái
  updateStatus: async (id: number, status: string): Promise<ViewYoutube> => {
    const response = await api.patch<ViewYoutube>(`/apiviewyoutube/${id}/status`, { status });
    return response.data;
  },

  // Cập nhật chi tiết (có lưu history)
  updateDetail: async (id: number, data: {
    content?: string;
    country?: string;
    view?: number;
    nameChannel?: string;
    seeder?: string;
    groupLink?: string;
    date?: string;
  }): Promise<ViewYoutube> => {
    const response = await api.patch<ViewYoutube>(`/apiviewyoutube/${id}/detail`, data);
    return response.data;
  },

  // Xem lịch sử thay đổi
  getHistory: async (id: number): Promise<ViewYoutubeHistory[]> => {
    const response = await api.get<ViewYoutubeHistory[]>(`/apiviewyoutube/${id}/history`);
    return response.data;
  },

  // Hoàn tác thay đổi
  revertHistory: async (historyId: number): Promise<ViewYoutube> => {
    const response = await api.post<ViewYoutube>(`/apiviewyoutube/history/${historyId}/revert`);
    return response.data;
  },

  // Xóa 1 video
  delete: async (id: number): Promise<{ success: boolean; message: string }> => {
    const response = await api.delete<{ success: boolean; message: string }>(`/apiviewyoutube/${id}`);
    return response.data;
  },

  // Xóa nhiều video
  deleteBatch: async (ids: number[]): Promise<{ success: boolean; message: string; deletedCount: number }> => {
    const response = await api.delete<{ success: boolean; message: string; deletedCount: number }>(
      '/apiviewyoutube/batch/delete',
      { data: { ids } }
    );
    return response.data;
  },

  // Lấy snapshots 7 ngày gần nhất
  getLast7DaysSnapshots: async (): Promise<DailySnapshot[]> => {
    const response = await api.get<DailySnapshot[]>('/daily-view-snapshot/youtube/last-7-days');
    return response.data;
  },

  // Lấy snapshot mới nhất
  getLatestSnapshot: async (): Promise<DailySnapshot> => {
    const response = await api.get<DailySnapshot>('/daily-view-snapshot/youtube/latest');
    return response.data;
  },

  // Tạo snapshot thủ công
  createSnapshot: async (): Promise<DailySnapshot> => {
    const response = await api.post<DailySnapshot>('/daily-view-snapshot/create/youtube');
    return response.data;
  },
};

